/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const AgentStatus = {
  Active: 'ACTIVE',
  Lunch: 'LUNCH',
  TrainingMeeting: 'TRAINING_MEETING',
  ShortBreak: 'SHORT_BREAK',
  ShiftWrapUp: 'SHIFT_WRAP_UP',
  Away: 'AWAY',
  Busy: 'BUSY',
} as const

export type AgentStatus = (typeof AgentStatus)[keyof typeof AgentStatus]
